import dayjs from "dayjs";
import { Button } from "../../Atoms/Button";
import { InputDate } from "../../Atoms/Inputs/InputDate";
import { Pagination } from "../../Atoms/Pagination";
import { SimpleSelect } from "../../Atoms/Selects/SimpleSelect";
import { LayoutTemplate } from "../../Templates/LayoutTemplate";
import * as S from "./styles";
import { useComplaints } from "./useComplaints";
import { ISelectOptions } from "../../../types/inputs";
export const Complaints = () => {
  const {
    data,
    isMobile,
    pagination,
    setNumberPage,
    setFilter,
    filter,
    ASSEDIO_OPTIONS,
    handleFilter,
    navigate,
  } = useComplaints();

  return (
    <LayoutTemplate title="Denuncias de Abuso">
      <S.Container>
        <S.Filter onSubmit={handleFilter}>
          <div>
            <label>Data Inicial</label>
            <InputDate
              showIcon
              isClearable
              selected={
                filter?.data_inicial
                  ? dayjs(filter?.data_inicial).toDate()
                  : null
              }
              onChange={(e) =>
                setFilter({
                  ...filter,
                  data_inicial: e ? dayjs(e).format("YYYY-MM-DD") : null,
                })
              }
            />
          </div>

          <div>
            <label>Data Final</label>
            <InputDate
              showIcon
              isClearable
              selected={
                filter?.data_final ? dayjs(filter?.data_final).toDate() : null
              }
              onChange={(e) =>
                setFilter({
                  ...filter,
                  data_final: e ? dayjs(e).format("YYYY-MM-DD") : null,
                })
              }
            />
          </div>

          <div>
            <label>Tipo de Assédio</label>
            <SimpleSelect
              options={ASSEDIO_OPTIONS}
              placeholder=""
              isClearable
              onChange={(e: ISelectOptions) =>
                setFilter({
                  ...filter,
                  tipo_assedio: e?.value || "",
                })
              }
            />
          </div>

          <div>
            <Button>Filtrar</Button>
          </div>
        </S.Filter>

        <S.Table>
          <S.TableHeader>
            <h3>Data</h3>
            <h3>Nome Acusado</h3>
            <h3>Cargo</h3>
            <h3>Tipo de Assédio</h3>
            <h3></h3>
          </S.TableHeader>

          {data?.length > 0 &&
            data?.map((i) => (
              <S.TableItem key={Math.random()}>
                <p>{dayjs(i?.data_ocorrencia).format("DD/MM/YYYY")}</p>
                <p>{i?.nome_acusado}</p>
                <p>{i?.cargo_acusado}</p>
                <p>{i?.tipo_assedio}</p>
                <S.WrapperIcon>
                  <img
                    onClick={() => navigate(`/denuncias/${i?.uuid}`)}
                    src="/assets/svg/icon-eye-black-open.svg"
                    alt="icone olho"
                  />
                </S.WrapperIcon>
              </S.TableItem>
            ))}

          {data?.length > 0 && (
            <Pagination
              maxPageNumbersDisplayed={isMobile ? 3 : 10}
              key={`${Math.random()} - ${pagination}`}
              totalPage={pagination.totalPage}
              totalRegister={pagination.totalPage}
              actualPage={pagination.actualPage}
              setNumberPage={setNumberPage}
            />
          )}
        </S.Table>
      </S.Container>
    </LayoutTemplate>
  );
};
